// extracted by mini-css-extract-plugin
export default {"app":"App_app__rGTmY","wrapper":"App_wrapper__rk1Tq"};